<template>
  <div class="proxy-history">
    <!-- 过滤 Tabs -->
    <div class="filter-tabs-wrapper">
      <div class="filter-tabs">
        <div
          v-for="opt in filterStatus"
          :key="opt.value"
          class="filter-tab"
          :class="{ active: activeFilter === opt.value }"
          @click="selectFilter(opt)"
        >
          {{ opt.label }}
        </div>
      </div>
    </div>

    <!-- 交易记录列表 -->
    <div class="order-list">
      <van-pull-refresh v-model="refreshing" @refresh="onRefresh">
        <van-list v-model:loading="loading" :finished="finished" finished-text="没有更多记录" @load="onLoad">
          <div v-for="item in list" :key="item.depositId" class="order-item" @click="viewDetail(item)">
            <div class="order-header">
              <div class="order-info">
                <span class="order-id">订单号:{{ item.depositId }}</span>
                <span class="order-time">{{ item.createdAt }}</span>
              </div>
              <div class="order-status">
                <van-tag size="large" v-if="item.tranType == 1" type="primary">充值</van-tag>
                <van-tag size="large" v-if="item.tranType == 2" type="success">提现</van-tag>
                <van-tag size="large" v-if="item.tranType == 3" type="primary">消费</van-tag>
                <van-tag size="large" v-if="item.tranType == 4" type="success">缴纳保证金</van-tag>
                <van-tag size="large" v-if="item.tranType == 5" type="primary">保证金退还</van-tag>
                <van-tag size="large" v-if="item.tranType == 6" type="success">平台回收充值</van-tag>
                <van-tag size="large" v-if="item.tranType == 7" type="primary">交易退款</van-tag>
                <van-tag size="large" v-if="item.tranType == 8" type="success">交易到账</van-tag>
                <van-tag size="large" v-if="item.tranType == 9" type="primary">商家赔付</van-tag>
                <van-tag size="large" v-if="item.tranType == 10" type="success">保证金扣除</van-tag>
                <van-tag size="large" v-if="item.tranType == 11" type="primary">游戏代充</van-tag>
              </div>
            </div>
            <div class="order-content">

              <div class="order-details">
                <div class="detail-row">
                  <span class="label">金额：</span>
                  <span class="price" :class="item.amountClass">{{ '￥' + item.ppAmount }} </span>
                </div>
                <div class="detail-row">
                  <span class="label">渠道：</span>
                  <span class="value" v-if="item.paymentChl == 1">微信</span>
                  <span class="value" v-if="item.paymentChl == 2">支付宝</span>
                  <span class="value" v-if="item.paymentChl == 3">余额</span>
                </div>

              </div>
              <div class="order-details">
                <div class="detail-row">
                  <span class="label">结账前余额:</span>
                  <span class="price" :class="item.amountClass">{{ '￥' + item.beforeBalance }} </span>
                </div>
                <div class="detail-row">
                  <span class="label">结账后余额:</span>
                  <span class="price" :class="item.amountClass">{{ '￥' + item.afterBalance }} </span>
                </div>

              </div>
            </div>
          </div>
        </van-list>
      </van-pull-refresh>
    </div>
    <!-- 空状态 -->
    <!-- <van-empty
      v-if="!loading && filteredTransactions.length === 0"
      image="search"
      description="暂无交易记录"
    /> -->
    <!-- 详情弹窗 -->
    <van-popup v-model:show="showDetail" position="bottom" :style="{ height: '50%' }" round>
      <div class="detail-popup">
        <div class="detail-header">
          <h3>交易详情</h3>
          <van-icon name="cross" @click="showDetail = false" />
        </div>
        <div v-if="selectedItem" class="detail-content">
          <div class="detail-section">
            <van-cell title="类型" :value="selectedItem.typeText">
              <template #value>
                <van-tag size="large" v-if="selectedItem.tranType == 1" type="primary">充值</van-tag>
                <van-tag size="large" v-if="selectedItem.tranType == 2" type="success">提现</van-tag>
                <van-tag size="large" v-if="selectedItem.tranType == 3" type="primary">消费</van-tag>
                <van-tag size="large" v-if="selectedItem.tranType == 4" type="success">缴纳保证金</van-tag>
                <van-tag size="large" v-if="selectedItem.tranType == 5" type="primary">保证金退还</van-tag>
                <van-tag size="large" v-if="selectedItem.tranType == 6" type="success">平台回收充值</van-tag>
                <van-tag size="large" v-if="selectedItem.tranType == 7" type="primary">交易退款</van-tag>
                <van-tag size="large" v-if="selectedItem.tranType == 8" type="success">交易到账</van-tag>
                <van-tag size="large" v-if="selectedItem.tranType == 9" type="primary">商家赔付</van-tag>
                <van-tag size="large" v-if="selectedItem.tranType == 10" type="success">保证金扣除</van-tag>
                <van-tag size="large" v-if="selectedItem.tranType == 11" type="primary">金币代充</van-tag>
                <van-tag size="large" v-if="selectedItem.tranType == 12" type="success">ID代充</van-tag>
              </template>
            </van-cell>
            <van-cell title="渠道" :value="selectedItem.typeText">
              <template #value>
                <span class="value" v-if="selectedItem.paymentChl == 1">微信</span>
                <span class="value" v-if="selectedItem.paymentChl == 2">支付宝</span>
                <span class="value" v-if="selectedItem.paymentChl == 3">余额</span>
              </template>
            </van-cell>
            <van-cell title="金额" :value="'￥' + selectedItem.ppAmount" />
            <van-cell title="结账前余额" :value="'￥' + selectedItem.beforeBalance" />
            <van-cell title="结账后余额" :value="'￥' + selectedItem.afterBalance" />
            <van-cell title="时间" :value="selectedItem.createdAt" />
          </div>
        </div>
      </div>
    </van-popup>
  </div>
</template>

<script>
import request from '@/utils/request'
export default {
  data() {
    return {
      activeFilter: '',
      transactions: [],
      list: [],
      loading: false,
      finished: false,
      page: 0,
      pageSize: 10,
      refreshing: false,
      showDetail: false,
      selectedItem: null,
      zijinForm: {},
      filterStatus:[
        {value: '', label: '全部'},
        {value: '98', label: '支出'},
        {value: '97', label: '收入'},
        {value: '6', label: '回收'},
        {value: '3', label: '购买'},
        {value: '8', label: '出售'},
      ]
    };
  },
  created() {
    // this.page = 1
    // this.getList()
  },
  methods: {
    selectFilter(opt) {
      this.activeFilter = opt.value;
      this.zijinForm.tranType = opt.value;
      this.list = [];
      this.page = 1;
      this.finished = false;
      this.getList();
    },
    getList() {
      if (this.finished) {
        return false
      }
      request.get('/front/capital/flow/list', {
        params: {
          pageNum: this.page,
          pageSize: 10,
          tranType: this.zijinForm.tranType,
        }
      }).then(res => {
        if (res.code == 200) {
          if (this.page === 1) {
            this.list = res.rows;
          } else {
            this.list = [...this.list, ...res.rows];
          }
          // 判断是否还有更多数据
          this.finished = this.list.length >= res.total;
        } else {
          this.finished = true;
        }
      }).finally(() => {
        this.loading = false;
      });
    },
    onLoad() {
      setTimeout(() => {
        this.page++;
        this.getList();
      }, 500);
    },
    onRefresh() {
      this.refreshing = true;
      setTimeout(() => {
        this.list = [];
        this.page = 1;
        this.finished = false;
        this.getList();
        this.refreshing = false;
      }, 500);
    },
    viewDetail(item) {
      this.selectedItem = item;
      this.showDetail = true;
    }
  }
};
</script>

<style scoped>
.proxy-history {
  background-color: #f7f8fa;
  height: 100%;
  display: flex;
  flex-direction: column;
}

.order-list {
  padding: 16px;
  overflow-y: scroll;
  min-height: 0;
}

.order-item {
  background: white;
  border-radius: 12px;
  padding: 16px;
  margin-bottom: 12px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
  transition: all 0.3s ease;
}

.order-item:active {
  transform: scale(0.98);
}

.order-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 12px;
  padding-bottom: 8px;
  border-bottom: 1px solid #f0f0f0;
}

.order-info {
  flex: 1;
}

.order-id {
  font-size: 14px;
  font-weight: 500;
  color: #323233;
  display: block;
  margin-bottom: 4px;
}

.order-time {
  font-size: 12px;
  color: #969799;
}

.status-success {
  color: #07c160;
}

.status-failed {
  color: #f53f3f;
}

.order-content {
  display: flex;
  gap: 12px;
  margin-bottom: 12px;
}

.order-avatar {
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
}

.order-details {
  flex: 1;
}

.detail-row {
  display: flex;
  margin-bottom: 6px;
  font-size: 14px;
}

.detail-row:last-child {
  margin-bottom: 0;
}

.label {
  color: #646566;
  width: 80px;
  flex-shrink: 0;
}

.value {
  color: #323233;
  flex: 1;
}

.price-row .price {
  color: #ee0a24;
  font-weight: 600;
}

/* 详情弹窗样式 */
.detail-popup {
  padding: 20px;
  height: 100%;
  overflow-y: auto;
}

.detail-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
  padding-bottom: 12px;
  border-bottom: 1px solid #ebedf0;
}

.detail-header h3 {
  margin: 0;
  font-size: 18px;
  font-weight: 600;
  color: #323233;
}

.detail-section {
  margin-bottom: 24px;
}
</style>

<style scoped>
.filter-tabs-wrapper {
  padding: 12px 16px;
  overflow-x: auto;
}
.filter-tabs {
  display: flex;
  gap: 8px;
}
.filter-tab {
  flex: 0 0 auto;
  white-space: nowrap;
  padding: 6px 14px;
  border-radius: 20px;
  background: #ffffff;
  border: 1px solid #f0f0f0;
  color: #333333;
  font-size: 14px;
  cursor: pointer;
  box-shadow: 0 1px 2px rgba(0,0,0,0.03);
}
.filter-tab.active {
  background: #1989fa;
  color: #ffffff;
  border-color: transparent;
}
</style>